<template>
  <el-scrollbar class="e6-nav-menu__scroll">
    <el-menu
      router
      :mode="mode"
      :collapse="collapse"
      :collapse-transition="false"
      :default-active="$route.path"
      background-color="#2157f0"
      text-color="#ffffff"
      active-text-color="#ffffff"
      :menu-trigger="menuTrigger"
      :unique-opened="true"
    >
      <template v-for="(firstMenu, firstIndex) in menus">
        <!-- 一级菜单无子集 -->
        <el-menu-item
          v-if="!firstMenu.children"
          :key="firstIndex"
          :index="firstMenu.path"
        >
          <!-- <i v-if="firstMenu.meta.icon" :class="firstMenu.meta.icon"></i> -->
          <i
            v-if="firstMenu.meta.icon && mode == 'vertical'"
            class="menu-icon icon-shouye"
          ></i>
          <span slot="title">{{ firstMenu.title }}</span>
        </el-menu-item>
        <!-- 一级菜单无子集  end -->
        <!-- 一级菜单有子集 -->
        <el-submenu v-else :key="firstIndex" :index="firstIndex + ''">
          <template slot="title">
            <i
              v-if="firstMenu.meta.icon && mode == 'vertical'"
              :class="firstMenu.meta.icon"
            ></i>
            <span>{{ firstMenu.title }}</span>
          </template>

          <!-- 二级菜单 -->
          <template v-for="(secondMenu, secondIndex) in firstMenu.children">
            <!-- 二级菜单 无子菜单 -->
            <el-menu-item
              v-if="!secondMenu.children"
              :key="firstIndex + '-' + secondIndex"
              :index="secondMenu.path"
            >
              <i v-if="secondMenu.meta.icon" :class="secondMenu.meta.icon"></i>
              <span slot="title">{{ secondMenu.title }}</span>
            </el-menu-item>
            <!-- 二级菜单 有子菜单 -->
            <el-submenu
              v-else
              :key="firstIndex + '-' + secondIndex"
              :index="firstIndex + '-' + secondIndex"
            >
              <template slot="title">
                <i
                  v-if="secondMenu.meta.icon"
                  :class="secondMenu.meta.icon"
                ></i>
                <span>{{ secondMenu.title }}</span>
              </template>
              <!-- 三级菜单暂时无子集 -->
              <!-- 三级菜单 -->
              <template v-for="(thirdMenu, thirdIndex) in secondMenu.children">
                <el-menu-item
                  background-color="#df4646"
                  :key="firstIndex + '-' + secondIndex + '-' + thirdIndex"
                  :index="thirdMenu.path"
                >
                  <i
                    v-if="thirdMenu.meta.icon"
                    :class="thirdMenu.meta.icon"
                  ></i>
                  <span slot="title">{{ thirdMenu.title }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-submenu>
        <!-- 一级菜单有子集 end -->
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    mode: {
      type: String,
      default: "horizontal"
    },
    collapse: {
      type: Boolean,
      default: true
    },
    menuTrigger: {
      type: String,
      default: "click"
    }
  },
  computed: {
    ...mapGetters(["menus"])
  }
};
</script>
<style lang="scss" scoped>
[class^="e6-icon"],
[class*=" e6-icon"] {
  display: inline-block;
  width: 24px;
  margin-right: 5px;
  font-size: 18px;
  color: inherit;
  background-color: initial;
  text-align: center;
  vertical-align: middle;
}

.el-scrollbar {
  height: 100%;
}
</style>
